module.exports = __webpack_public_path__ + "assets/adroll.bc5cef93.svg";